import React from "react";

const PatientEnrollIcon = ({ style, color = "white", ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    {...props}
  >
    <path
      d="M18.7437 18.6767C18.4575 19.4915 18.1664 20.1954 17.9233 20.6166C16.875 22.4329 15.7936 17.2064 15.7936 17.2064C15.7936 17.2064 10.5671 16.125 12.3834 15.0763C13.9161 14.1917 19.1985 12.6708 19.9365 13.0635C20.1516 13.4681 19.7925 15.2364 19.2779 17.0052"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 17L18 15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13.535 8.077C13.535 9.15829 13.1054 10.1953 12.3409 10.9599C11.5763 11.7245 10.5393 12.154 9.45798 12.154C8.37669 12.154 7.33969 11.7245 6.57511 10.9599C5.81052 10.1953 5.38098 9.15829 5.38098 8.077C5.38098 6.99571 5.81052 5.95871 6.57511 5.19413C7.33969 4.42954 8.37669 4 9.45798 4C10.5393 4 11.5763 4.42954 12.3409 5.19413C13.1054 5.95871 13.535 6.99571 13.535 8.077Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.07397 19.8098C3.07397 17.7268 4.71797 15.1328 9.45697 15.1328"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PatientEnrollIcon;
